import React, { PureComponent } from 'react'
import PageHeaderWrapper from '../../../components/PageHeaderWrapper'
import { Form, Button, Card, Input, Tooltip, Popconfirm, Tag } from 'antd'
import _ from 'lodash'
import { TableComp } from 'sz-react-utils'
import 'react-quill/dist/quill.snow.css'
import { notification } from 'antd/lib/index'
import { hideLoader, showLoader } from '../../../modules/actions'
import Request from '../../../request'
import { connect } from 'react-redux'
import moment from 'moment'

@Form.create()
class AddLabel extends PureComponent {
  constructor(props) {
    super(props)
    this.table = React.createRef()
    this.state = {}
  }

  handleSubmit = (e) => {
    const { dispatch, form } = this.props
    e.preventDefault()
    form.validateFieldsAndScroll(async (err, valData) => {
      if (!err) {
        const name = _.trim(valData.name)
        if (!name) {
          return notification.error({
            message: 'Please input tag',
          })
        }

        dispatch(showLoader())
        const x = await Request.addTag({ name })
        dispatch(hideLoader())

        if (!x.error) {
          notification.success({
            message: x.message,
          })
          this.props.form.resetFields()
          this.table.current.reload()
        } else {
          notification.error({
            message: 'Error Saving',
            description: x.message,
          })
        }
      }
    })
  }

  apiRequest = (params) => {
    return new Promise(async (resolve) => {
      if (!params.sortField) {
        params.sortField = 'createdAt'
        params.sortOrder = 'descend'
      }

      const data = await Request.getAllTags({
        ...params,
        regExFilters: ['name'],
      })

      this.setState({ count: data.total })
      resolve(data)
    })
  }

  deleteTag = async (data) => {
    this.setState({ loading: true })
    const x = await Request.deleteTag(data)
    this.setState({ loading: false })

    this.table.current.reload()
    if (!x.error) {
      notification.success({
        message: x.message,
        duration: 20,
        key: `${data._id}-close`,
      })
    } else {
      notification.error({
        message: x.message,
        duration: 20,
        key: `${data._id}-close`,
      })
    }
  }

  render() {
    const {
      form: { getFieldDecorator },
    } = this.props

    const columns = [
      {
        title: 'Tag',
        key: 'name',
        dataIndex: 'name',
        searchTextName: 'name',
      },
      {
        title: 'Created At',
        key: 'createdAt',
        dataIndex: 'createdAt',
        sorter: true,
        render: (text) => {
          return <Tag>{text ? moment(text).format('lll') : ''}</Tag>
        },
      },
      {
        key: 'actions',
        title: 'Actions',
        render: (text, record) => {
          return (
            <React.Fragment>
              <Tooltip title="Delete Tag">
                <Popconfirm
                  title="Are you sure to delete this tag?"
                  onConfirm={() => {
                    this.deleteTag({ _id: record._id })
                  }}
                  onCancel={() => {}}
                  okText="Yes"
                  cancelText="No">
                  <Button shape="circle" size="small" icon="delete" />
                </Popconfirm>
              </Tooltip>
            </React.Fragment>
          )
        },
      },
    ]

    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
        md: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
        md: { span: 12 },
      },
    }

    const submitFormLayout = {
      wrapperCol: {
        xs: { span: 24, offset: 0 },
        sm: { span: 10, offset: 7 },
        md: { span: 12, offset: 8 },
      },
    }

    return (
      <PageHeaderWrapper title={this.state.id ? 'Update Tag' : 'Add Tag'}>
        <Card bordered={true}>
          <Form onSubmit={this.handleSubmit} hideRequiredMark>
            <div>
              <Form.Item label={'Tag'} {...formItemLayout}>
                {getFieldDecorator('name', {
                  rules: [
                    {
                      required: true,
                      message: `Please input tag`,
                    },
                  ],
                })(<Input />)}
              </Form.Item>

              <Form.Item {...submitFormLayout}>
                <Button type="primary" htmlType="submit" loading={this.props.loading}>
                  ADD
                </Button>
              </Form.Item>
            </div>
          </Form>
        </Card>

        <Card bordered={true}>
          <h3>{this.state.count ? `All Tags: ${this.state.count}` : `All Tags: 0`}</h3>

          <TableComp
            ref={this.table}
            columns={columns}
            apiRequest={this.apiRequest}
            pagination={{
              ...this.state.pagination,
              defaultPageSize: 10,
              pageSizeOptions: ['10', '25', '50', '100'],
              showSizeChanger: true,
              ...this.props.pagination,
            }}
          />
        </Card>
      </PageHeaderWrapper>
    )
  }
}

const mapStateToProps = ({ global, router }) => ({
  loading: global.buttonLoading,
  categories: global.categories,
  search: router.location.search,
})
const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AddLabel)
